import React from 'react';
import GenDataText from '../../GenDataText';

const GlobalColumns = t => {
  return [
    {
      id: 'price',
      label: t('detail.servicesTable.servicesColumnLabels.priceLabel'),
      labelComponent: (
        <GenDataText textVariant="body1" textColor="textPrimary" />
      ),
      component: (
        <GenDataText
          textVariant="body2"
          textColor="textPrimary"
          currency={true}
        />
      ),
      dataSource: ['price'],
      align: 'left',
      sx: { display: { xs: 'none', lg: 'table-cell' } },
    },
    {
      id: 'ordered',
      label: t('detail.servicesTable.servicesColumnLabels.orderedLabel'),
      labelComponent: (
        <GenDataText textVariant="body1" textColor="textPrimary" />
      ),
      component: <GenDataText textVariant="body2" textColor="textPrimary" />,
      dataSource: ['requester.firstName', ' ', 'requester.lastName'],
      defaultValue: ' ',
      align: 'left',
    },
    {
      id: 'approved',
      label: t('detail.servicesTable.servicesColumnLabels.approvedLabel'),
      labelComponent: (
        <GenDataText textVariant="body1" textColor="textPrimary" />
      ),
      component: <GenDataText textVariant="body2" textColor="textPrimary" />,
      dataSource: ['approver.firstName', ' ', 'approver.lastName'],
      defaultValue: ' ',
      align: 'left',
    },
  ];
};

export default GlobalColumns;
